import APIService from '@/services/api.service';
import UserService from '@/services/user.service';
import Q from 'q';

class UserInvitationsService {

    constructor() {}

    getInvitationsForDocumentSet(setId) {
        var settings = APIService.defaultSettingsPlus({
            url : APIService.baseURL + '/api/v1/documentsets/' + setId + '/userinvitations'
        });
        return APIService.waitFor( Q($.ajax(settings)) )
            .then(result => result.entities);
    }

    postInvitationForDocumentSet(setId, payload) {
        if (payload.userFirstName === '' || payload.userLastName === '' || payload.userEmail === '') {
            return APIService.waitFor( Q.reject( { statusText:'Must complete all fields.' } ) );
        }
        var settings = APIService.defaultSettingsPlus({
            url : APIService.baseURL + '/api/v1/documentsets/' + setId + '/userinvitations',
            method: 'POST',
            data: {
                user_invitation: payload
            },
            // dataType has to be 'text' for jQuery to treat the empty response for a 201 'created' as a success.
            dataType:'text'
        });
        return APIService.waitFor( Q($.ajax(settings)) );
    }

    postInvitationsForDocumentSet(setId, payloads) {
        var promises = payloads.map(payload => this.postInvitationForDocumentSet(setId, payload));
        return Q.all(promises);
    }

    revokeAccessForDocumentSet(setId, invitation) {
        var settings = APIService.defaultSettingsPlus({
            url : APIService.baseURL + '/api/v1/documentsets/' + setId + '/userlinks/' + invitation.id,
            method: 'DELETE',
            dataType: 'text'
        });
        return APIService.waitFor( Q($.ajax(settings)) );
    }

    getInvitationWithToken(invitationId, token) {
        var settings = APIService.defaultSettingsPlus({
            url : APIService.baseURL + '/api/v1/userinvitations/' + invitationId + '?token=' + token,
        });
        return APIService.waitFor( Q($.ajax(settings)), true )
            .then(result => result.entity);
    }

    getInvitationsForUser() {
        return UserService.get()
            .then(requestInvitationsFor);

        function requestInvitationsFor(user) {
            var settings = APIService.defaultSettingsPlus({
                url : APIService.baseURL + '/api/v1/users/' + user.id + '/userinvitations'
            });
            return APIService.waitFor( Q($.ajax(settings)) )
                .then(result => result.entities)
                .then(invitations => invitations.filter(invitation => invitation.shareStatus=='invited'));
        }
    }

    handleInvitation(invitation, status) {
        var settings = APIService.defaultSettingsPlus({
            url: APIService.baseURL + '/api/v1/userinvitations/' + invitation.id,
            method:'PUT',
            // dataType has to be 'text' for jQuery to treat the empty response for a 204 'modified' as a success.
            dataType:'text',
            data: {
                user_invitation: {
                    shareStatus: status,
                    tokenConfirmation: invitation.invitationToken,
                    version: invitation.version
                }
            }
        });
        return APIService.waitFor( Q($.ajax(settings)) );
    }

    acceptInvitation(invitation) {
        return this.handleInvitation(invitation, 'accepted');
    }

    declineInvitation(invitation) {
        return this.handleInvitation(invitation, 'declined');
    }


}

export default new UserInvitationsService();


// WEBPACK FOOTER //
// ./src/services/user-invitations.service.js